/* eslint-disable no-nested-ternary */
import React from 'react';
import { useSelector } from 'react-redux';
import SimulationAdvancement from '@components/Modal/AdvancementModal/SimulationAdvancement';
import StatusAdvancement from 'components/Modal/AdvancementModal/AdvancementStatus';
import { advancementStatus } from '@constants/advancement';

const AdvancementModal = ({ handleCancel, liquidationAmount }) => {
  const status = useSelector((state) => state.advancements.advancementStatus.status);
  return status === null ? (
    <SimulationAdvancement handleCancel={handleCancel} liquidationAmount={liquidationAmount} />
  ) : (
    <StatusAdvancement status={advancementStatus[status]} />
  );
};

export default AdvancementModal;
